import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContentType, ModuleType, QuestionType } from 'src/app/API.service';
import { environment } from 'src/environments/environment';
import { FeedbackType } from '../feedback-type';

@Component({
  selector: 'app-module-form-question',
  templateUrl: './module-form-question.component.html',
  styleUrls: ['./module-form-question.component.scss']
})
export class ModuleFormQuestionComponent implements OnInit {

  @Input() moduleType: ModuleType = null;
  @Input() pageGroup: FormGroup = null;

  ModuleType = ModuleType;
  QuestionType = QuestionType;
  FeedbackType = FeedbackType;
  ContentType = ContentType;
  MinScaleLength = 3
  MaxScaleLength = 10
  ScaleLengths = [...Array((this.MaxScaleLength + 1) - this.MinScaleLength).keys()].map(i => i + this.MinScaleLength)
  feedbackImageFiles = {};

  get questionFormGroup() : FormGroup {
    if (this.pageGroup != null){
      return this.pageGroup.controls['question'] as FormGroup;
    }
    return null;
  }

  get videos() : FormArray {
    if (this.questionFormGroup != null){
      return this.questionFormGroup.controls['videos'] as FormArray
    }
    return new FormArray([]);
  }

  get feedbacks() : FormArray {
    if (this.questionFormGroup != null){
      return this.questionFormGroup.controls['feedbacks'] as FormArray
    }
    return new FormArray([]);
  }

  get options() : FormArray {
    if (this.questionFormGroup != null){
      return this.questionFormGroup.controls['options'] as FormArray
    }
    return new FormArray([]);
  }

  get scales() : FormArray {
    if (this.questionFormGroup != null){
      return this.questionFormGroup.controls['scales'] as FormArray
    }
    return new FormArray([]);
  }

  get feedbackType() : FeedbackType {
    return this.questionFormGroup.controls['feedbackType'].value
  }

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  addFeedbackContent(feedbackIndex: number, type: ContentType, file: string = '', src: string = '', imageKey: string = ''){

    var feedbacksFormArray = this.questionFormGroup.controls.feedbacks as FormArray;
    var feedbackFormGroup = feedbacksFormArray.controls[feedbackIndex] as FormGroup;
    var contentsFormArray = feedbackFormGroup.controls.contents as FormArray;
    contentsFormArray.push(this.newContentFormGroup(type, ''))

    if (type == ContentType.IMAGE) {

      this.addFeedbackImage(feedbackIndex, contentsFormArray.length - 1, file, src, imageKey)

    }

  }
  addFeedbackImage(feedbackIndex, contentIndex, file, src, imageKey){

    if (!this.feedbackImageFiles[feedbackIndex]){
      this.feedbackImageFiles[feedbackIndex] = {}
    }

    this.feedbackImageFiles[feedbackIndex][contentIndex] = {
      file: file,
      src: src,
      key: imageKey
    }
  }
  addOption(){
    var optionsFormArray = this.questionFormGroup.controls.options as FormArray
    optionsFormArray.push(this.newOptionFormGroup('', false))
    this.onQuestionFeedbackTypeChange();
  }
  addQuestionScale(){

    var scalesFormArray = this.questionFormGroup.controls.scales as FormArray;
    
    var defaultMinLabel = this.questionFormGroup.controls.defaultMinLabel.value
    var defaultMaxLabel = this.questionFormGroup.controls.defaultMaxLabel.value

    scalesFormArray.push(this.newQuestionScaleGroup(null, null, null, defaultMinLabel, defaultMaxLabel))

  }
  addQuestionVideo(){
    var videosFormArray = this.questionFormGroup.controls.videos as FormArray;
    videosFormArray.push(this.newVideoFormControl())
  }

  removeFeedbackContent(feedbackIndex, contentIndex){

    if (contentIndex == 0) return;

    var feedbacksFormArray = this.questionFormGroup.controls.feedbacks as FormArray;
    var feedbackFormGroup = feedbacksFormArray.controls[feedbackIndex] as FormGroup
    var contentsFormArray = feedbackFormGroup.controls.contents as FormArray;
    contentsFormArray.removeAt(contentIndex)

    for(var i = contentIndex; i < contentsFormArray.controls.length; i++) {
      if (this.feedbackImageFiles[feedbackIndex][i + 1]) {
        this.feedbackImageFiles[feedbackIndex][i] = this.feedbackImageFiles[feedbackIndex][i + 1];        
        delete this.feedbackImageFiles[feedbackIndex][i + 1];
      }
    }

  }
  removeFeedbackImage(feedbackIndex, contentIndex){
    var feedbacksFormArray = this.questionFormGroup.controls.feedbacks as FormArray;
    var feedbackFormGroup = feedbacksFormArray.controls[feedbackIndex] as FormGroup
    var contentsFormArray = feedbackFormGroup.controls.contents as FormArray;
    var contentFormGroup = contentsFormArray.controls[contentIndex] as FormGroup;

    contentFormGroup.controls.value.setValue('')

    this.feedbackImageFiles[feedbackIndex][contentIndex] = { 
      src: '',
      file: '',
      key: ''
    };
  }
  removeOption(optionIndex){

  }
  removeQuestionScale(scaleIndex){
    var scalesFormArray = this.questionFormGroup.controls.scales as FormArray;
    scalesFormArray.removeAt(scaleIndex);

    if (scalesFormArray.controls.length == 1){

      this.questionFormGroup.controls.defaultMinLabel.setValue(null);
      this.questionFormGroup.controls.defaultMaxLabel.setValue(null);

      (scalesFormArray.controls[0] as FormGroup).controls.minLabel.enable();
      (scalesFormArray.controls[0] as FormGroup).controls.maxLabel.enable();

    }
  }
  removeQuestionVideo(videoIndex){
    var videosFormArray = this.questionFormGroup.controls.videos as FormArray;
    videosFormArray.removeAt(videoIndex);
  }

  onDefaultLabelChange(){
    var scalesArray = this.questionFormGroup.controls.scales as FormArray;

    scalesArray.controls.forEach((scaleGroup : FormGroup) => {

      var defaultMinLabel = this.questionFormGroup.controls.defaultMinLabel.value
      var defaultMaxLabel = this.questionFormGroup.controls.defaultMaxLabel.value

      scaleGroup.patchValue({minLabel: defaultMinLabel, maxLabel: defaultMaxLabel})

      var minLabelControl = scaleGroup.controls.minLabel;
      var maxLabelControl = scaleGroup.controls.maxLabel;

      if (defaultMinLabel) {
        minLabelControl.disable()
      } else {
        minLabelControl.enable()
      }

      if (defaultMaxLabel) {
        maxLabelControl.disable()
      } else {
        maxLabelControl.enable()
      }

      var scaleLabelControl = scaleGroup.controls.scaleLabel;
      if (defaultMinLabel || defaultMaxLabel) {
        scaleLabelControl.setValidators([Validators.required])
      } else {
        scaleLabelControl.setValidators([])
      }
      scaleLabelControl.updateValueAndValidity();

    })
  }
  onFeedbackImageChange(feedbackIndex, contentIndex, event){
    this.feedbackImageFiles[feedbackIndex][contentIndex].key = null;
    this.feedbackImageFiles[feedbackIndex][contentIndex].file = event.target.files[0];

    var fileReader = new FileReader();
    fileReader.onload = () => {
      this.feedbackImageFiles[feedbackIndex][contentIndex].src = fileReader.result as string
    }
    fileReader.readAsDataURL(event.target.files[0]);
    var feedbacksFormArray = this.questionFormGroup.controls.feedbacks as FormArray;
    var feedbackFormGroup = feedbacksFormArray.controls[feedbackIndex] as FormGroup
    var contentsFormArray = feedbackFormGroup.controls.contents as FormArray;
    var contentFormGroup = contentsFormArray.controls[contentIndex] as FormGroup;
    contentFormGroup.controls.value.setValue(event.target.files[0].name)
  }
  onQuestionCorrectCheckChange(){
    var optionsFormArray = this.questionFormGroup.controls.options as FormArray;

    this.questionFormGroup.controls.hasAnswer.setValue(!optionsFormArray.controls.every(o => !((o as FormGroup).controls.checked.value)));
  }
  onQuestionCorrectRadioChange(optionIndex) {
    var optionsFormArray = this.questionFormGroup.controls.options as FormArray;

    optionsFormArray.controls.forEach((optionFormGroup, i) => {
      (optionFormGroup as FormGroup).controls.checked.setValue(i == optionIndex)
    });

    this.questionFormGroup.controls.hasAnswer.setValue(true)
  }
  onQuestionFeedbackTypeChange(){

    var optionsFormArray = this.questionFormGroup.controls.options as FormArray
    var feedbacksFormArray = this.questionFormGroup.controls.feedbacks as FormArray

    var newFeedbackType = this.questionFormGroup.controls.feedbackType.value;

    feedbacksFormArray.clear()

    if (newFeedbackType == FeedbackType.OPTION) 
    {

      while (feedbacksFormArray.controls.length != optionsFormArray.controls.length) {
        feedbacksFormArray.push(this.newFeedbackFormGroup(true))
      }

    } else if (newFeedbackType == FeedbackType.DEFAULT) {
     
      feedbacksFormArray.push(this.newFeedbackFormGroup(true))

    } else if (newFeedbackType == FeedbackType.CORRECT) {

      feedbacksFormArray.push(this.newFeedbackFormGroup(true))
      feedbacksFormArray.push(this.newFeedbackFormGroup(true))

    }

  }

  newContentFormGroup(type: ContentType, value: string) : FormGroup {
    return this.formBuilder.group({
      type: this.formBuilder.control(type, [Validators.required]),
      value: this.formBuilder.control(value, [Validators.required])
    })
  }
  newFeedbackFormGroup(includeDefaultContent: boolean) : FormGroup {
    var contents = []

    if (includeDefaultContent) {
      contents.push(this.newContentFormGroup(ContentType.TEXT, ''))
    }

    return this.formBuilder.group({
      contents: this.formBuilder.array(contents, [Validators.required])
    })
  }
  newOptionFormGroup(value: string, checked: boolean) : FormGroup {
    return this.formBuilder.group({
      value: this.formBuilder.control(value, [Validators.required]),
      checked: this.formBuilder.control(checked, [Validators.required])
    })
  }
  newQuestionScaleGroup(scaleLabel: string = null, minLabel: string = null, maxLabel: string = null, defaultMinLabel: string = null, defaultMaxLabel: string = null) : FormGroup {
    var scaleLabelValidators = [];

    var minLabelValue = minLabel;
    var minLabelDisabled = false;

    if (defaultMinLabel) {
      minLabelValue = defaultMinLabel;
      minLabelDisabled = true;
      scaleLabelValidators = [Validators.required];
    }

    var maxLabelValue = maxLabel;
    var maxLabelDisabled = false;

    if (defaultMaxLabel) {
      maxLabelValue = defaultMaxLabel;
      maxLabelDisabled = true;
      scaleLabelValidators = [Validators.required];
    }

    return this.formBuilder.group({
      scaleLabel: this.formBuilder.control(scaleLabel, scaleLabelValidators),
      minLabel: this.formBuilder.control({ value: minLabelValue, disabled: minLabelDisabled }, [Validators.required]),
      maxLabel: this.formBuilder.control({ value: maxLabelValue, disabled: maxLabelDisabled }, [Validators.required])
    })
  }
  newVideoFormControl(value: string = '', required : boolean = true) : FormControl {

    var validators = [
      Validators.pattern(environment.VimeoUrlRegExp)
    ]

    if (required) {
      validators.push(Validators.required)
    }

    return this.formBuilder.control(value, validators)
    
  }

}
